import "../utils/antdDefaults";
import React from "react";
import * as Sentry from '@sentry/react';
import { render } from "react-dom";
import Index from "../routes/Index";

document.addEventListener("DOMContentLoaded", () => {
  if(process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: "https://b254172a0038c55795ec4962e87a6155@sentry.mijora.dev/16",
      integrations: [
        new Sentry.BrowserTracing(),
      ],
      tracesSampleRate: 1.0,
    });
  }
 
  render(<><Index /></>, document.body.appendChild(document.createElement("div")));
});
